var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"l-achievement-top",attrs:{"src":require("./images/back-top.png"),"width":"100%","alt":""}}),_c('img',{staticClass:"l-achievement-bottom",attrs:{"src":require("./images/back-stage.png"),"width":"100%","alt":""}})])
}]

export { render, staticRenderFns }